import React from 'react';
import styles from './CategoryTabs.module.css';

interface CategoryTabsProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
  className?: string;
}

/**
 * Shared category tabs component for the explore view
 * Used by both mobile and desktop views
 */
const CategoryTabs: React.FC<CategoryTabsProps> = ({ 
  categories, 
  activeCategory, 
  onCategoryChange, 
  className 
}) => {
  return (
    <div className={`${styles.categoriesScroll} ${className || ''}`}>
      {categories.map((category, index) => (
        <button 
          key={index} 
          className={`${styles.categoryPill} ${category === activeCategory ? styles.active : ''}`}
          onClick={() => onCategoryChange(category)}
          aria-pressed={category === activeCategory}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default CategoryTabs; 